import ApiService from "../../services/api";
import moment from "moment";
import alarmsMap from "./map.vue";
import helpers from "../../shared/fleetbox-helpers";
import horizontalTable from "./horizontalTable.vue";
import { bus } from "../../main";
import { mapGetters } from "vuex";

export default {
	components: {
		alarmsMap,
		horizontalTable
	},

	data: function() {
		return {
			vehicleIdFilterField: "number_plate",
			loading: false,
			positionNamePendingRequests: [],

			//filters
			showTableMapPopover: false,
			mapTableVisualizationSelected: "",
			showMap: true,
			showHorizontalTable: true,

			vehicles: [],
			vehiclesSelected: [],

			drivers: [],
			driversSelected: [],

			events: [],
			eventsSelected: [],
			eventsForQuery: [],

			startDate: null,
			endDate: null,
			startTime: null,
			endTime: null,

			isVehicleFilterSelected: true,
			isDriverFilterSelected: false,

			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #",

			itemVehicleTemplate: "<div style='height: 30px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			tagVehicleTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",

			itemDriverTemplate: "<div style='height: 30px'>#= surname # #= name # <br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			tagDriverTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= surname # #= name # <br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",

			//alarms
			alarmItems: [],
			configColumns: [],

			//map
			config: {
				mapInitialLocation: {
					lat: 43.1107,
					lng: 12.3908
				}
			},
			alarmsMarker: [],

			//table
			tableParams: {
				pageSize: 25
			},
			totalCount: 0,
			canExportGridData: false,
			useReverseGeocoding: false,

			filtersByQuery: false
		};
	},

	created() {
		if (this.settings && this.settings.alarms.viewType) {
			if (this.settings.alarms.viewType == "map, horizontalGrid") {
				this.showMap = true;
				this.showHorizontalTable = true;
			} else if (this.settings.alarms.viewType == "horizontalGrid") {
				this.showMap = false;
				this.showHorizontalTable = true;
			} else {
				this.showMap = true;
				this.showHorizontalTable = false;
			}
		}

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "number_plate";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicle_code";
		}

		var icon = helpers.getIconForVisualizationType(this.showMap, this.showHorizontalTable, false);
		this.mapTableVisualizationSelected = `../../${icon}`;

		if (this.settings && this.settings.canExportGridData) {
			this.canExportGridData = true;
		}

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.tableParams.pageSize = parseInt(this.settings.defaultPageSize);
		}

		if (this.settings && this.settings.alarms && this.settings.alarms.useReverseGeocoding) this.useReverseGeocoding = this.settings.alarms.useReverseGeocoding;

		if (this.$route.query && this.$route.query.vehicleId) {
			this.filtersByQuery = true;
		}

		this.defaultFilterDateRange();
		this.getAllEvents();
		this.getAllVehicles();
		this.getAllDrivers();
		this.getConfig();

		bus.$emit("show-spinner-loading");
	},

	mounted() {},

	watch: {
		showTableMapPopover() {
			var self = this;

			self.$root.$emit("bv::hide::tooltip");
			setTimeout(() => {
				self.$root.$emit("bv::hide::tooltip");
			}, 700);
		}
	},

	methods: {
		//#region filters
		showMaptable(v) {
			if (v == "ht") {
				this.showHorizontalTable = !this.showHorizontalTable;
			} else if (v == "m") {
				this.showMap = !this.showMap;
			}

			if (!this.showHorizontalTable && !this.showMap) this.showMap = this.showHorizontalTable = true;

			var icon = helpers.getIconForVisualizationType(this.showMap, this.showHorizontalTable, false);
			this.mapTableVisualizationSelected = `../../${icon}`;

			this.onCloseShowTableMapPopover();
		},
		onCloseShowTableMapPopover() {
			this.showTableMapPopover = false;
		},
		onFilterDaterangeChange(e) {
			if (e.reset) {
				this.startTime = null;
				this.endTime = null;
				this.defaultFilterDateRange();
			} else if (e.type == "date") {
				this.startDate = e.startDate;
				this.endDate = e.endDate;
			} else if (e.type == "time") {
				this.startTime = e.startTime;
				this.endTime = e.endTime;
			}
		},
		onVehicleDriverFilterSelected(e) {
			if (e.indices[0] === 0) {
				//vehicle select
				this.isDriverFilterSelected = false;
				this.isVehicleFilterSelected = true;
				this.driversSelected = [];
			} else {
				//driver select
				this.isVehicleFilterSelected = false;
				this.isDriverFilterSelected = true;
				this.vehiclesSelected = [];
			}
		},
		defaultFilterDateRange() {
			var startTime = moment()
				.add(-1, "days")
				.startOf("day");
			this.startDate = startTime; //max from api
			var endDate = moment().endOf("days");
			this.endDate = endDate;
		},
		startDateChange(item) {
			var newStartDate = moment(item.sender.value()).startOf("days");
			if (newStartDate > moment(this.endDate)) {
				var m = moment(item.sender.value()).endOf("days");
				this.endDate = m;
			}
			this.startDate = newStartDate;
			//this.getAlarms();
		},

		endDateChange(item) {
			var newEndDate = moment(item.sender.value()).endOf("days");
			if (newEndDate < moment(this.startDate)) {
				var m = moment(item.sender.value()).startOf("days");
				this.startDate = m;
			}
			this.endDate = newEndDate;

			//this.getAlarms();
		},

		filterPlateChange(e) {
			this.vehiclesSelected = e.sender.value();
			this.resetTablePagination();
			//this.getAlarms();
		},
		filterDriverChange(e) {
			this.driversSelected = e.sender.value();
			this.resetTablePagination();
			//this.getAlarms();
		},
		applyFilter() {
			this.getAlarms();
		},
		resetFilter() {
			this.vehiclesSelected = [];
			this.driversSelected = [];
			this.eventsSelected = [];
			this.defaultFilterDateRange();
			this.resetTablePagination();
			this.getAlarms();
		},
		setDefaultQueryParams() {
			this.tableParams = {
				page: 0,
				pageSize: 25,
				sort: "",
				sortDirection: ""
			};
		},
		resetTablePagination() {
			this.tableParams.page = 0;
			bus.$emit("reset-table-pagination");
		},
		getAllEvents() {
			var self = this;
			ApiService.getVehicleEventsData("alarm").then(res => {
				self.eventsForQuery = res
					.filter(function(item) {
						return item.description && item.description.length > 0;
					})
					.map(function(item) {
						return {
							id: item.description.toLowerCase(),
							value: item.description.toLowerCase(),
							queryValue: `${item.box_payload_id}${item.box_type_id ? "_" + item.box_type_id : ""}${item.box_cat_id ? "_" + item.box_cat_id : ""}`
						};
					});

				for (var i = 0; i < self.eventsForQuery.length; i++) {
					var evt = self.eventsForQuery[i];
					var existsEvent = self.events.findIndex(item => {
						return item.id == evt.id;
					});
					if (existsEvent < 0) {
						self.events.push(evt);
					}
				}

				self.events = self._.sortBy(self.events, function(item) {
					return item.id;
				});
			});
		},
		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate,
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
					};
				});
			});
		},
		getAllDrivers() {
			var self = this;
			ApiService.getDriversData({ page: 0, pageSize: 100000, onlyActiveWithBox: true }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: driver.id,
						name: driver.name ? driver.name.toLowerCase() : "",
						surname: driver.surname ? driver.surname.toLowerCase() : "",
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname", "name"]);

				self.drivers.unshift({
					id: 0,
					name: "NON DISPONIBILE",
					surname: "",
					fiscal_code: ""
				});
			});
		},
		//#endregion

		//#region table
		downloadXlsx(type) {
			var self = this;
			var query = this.getQueryParams();
			if (type == "csv") query["format"] = "csv";
			ApiService.exportXlsx("alarms", query).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Allarmi.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		onSortOrPageChangeHandler(query) {
			this.tableParams = query;
			this.getAlarms();
		},
		onVisibilityItemChange(dataItem) {
			if (dataItem) {
				if (dataItem.visible) {
					var itemToShow = this.alarmItems.find(function(item) {
						return item.id === dataItem.id;
					});

					var indexOfMarker = this.alarmsMarker.findIndex(function(item) {
						return item.id == dataItem.id;
					});

					if (indexOfMarker < 0) {
						this.alarmsMarker.push(itemToShow);
					}
				} else {
					var markerToRemoveIndex = this.alarmsMarker.findIndex(function(item) {
						return item.id === dataItem.id;
					});

					if (markerToRemoveIndex >= 0) {
						this.alarmsMarker.splice(markerToRemoveIndex, 1);
					}
				}
			}
		},
		onSelectedRow(e) {
			var itemToShow = this.alarmItems.find(function(item) {
				return item.id === e.id;
			});

			if (itemToShow && itemToShow.position) {
				itemToShow.visible = true;

				var alreadyExistItem =
					this.alarmsMarker.findIndex(function(item) {
						return item.id === e.id;
					}) >= 0;

				if (!alreadyExistItem) {
					this.alarmsMarker.push(itemToShow);
				} else {
					bus.$emit("on-alarms-selected-row", e);
				}
			}
		},
		//#endregion

		//#region map
		onMarkerClick(e) {
			bus.$emit("alarm-marker-click", e);
		},
		//#endregion

		//#region Alarms
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_alarms").then(res => {
				self.configColumns = res;

				// if (res && res.length) {
				// 	var positionDisplayNameField = res.find(function(item) {
				// 		return item.field == valoredelcampodacercare;
				// 	});

				// 	if (positionDisplayNameField && positionDisplayNameField.enabled == false) {
				// 		this.useReverseGeocoding = false;
				// 	}
				// }

				self.getAlarms();
			});
		},
		setDateTimeFilter() {
			var startTime = null;
			if (this.startTime) {
				startTime = moment(this.startTime);
			}
			var endTime = null;
			if (this.endTime) {
				endTime = moment(this.endTime);
			}

			if (this.startDate) {
				if (startTime) {
					this.startDate.set({
						hour: startTime.get("hour"),
						minute: startTime.get("minute"),
						second: startTime.get("second")
					});
				} else {
					this.startDate = this.startDate.startOf("days");
				}
			}

			if (this.endDate) {
				if (endTime) {
					this.endDate.set({
						hour: endTime.get("hour"),
						minute: endTime.get("minute"),
						second: endTime.get("second")
					});
				} else {
					this.endDate = this.endDate.endOf("days");
				}
			}
		},
		getQueryParams() {
			var query = {};

			var self = this;
			let filterPlatesSelected = [];

			for (var i = 0; i < this.vehiclesSelected.length; i++) {
				let vehicleId = this.vehiclesSelected[i];
				let vehicle = this.vehicles.find(function(x) {
					return x.id == vehicleId;
				});

				if (this.vehicleIdFilterField == "code") {
					if (vehicle) filterPlatesSelected.push(vehicle.id);
				} else {
					if (vehicle) filterPlatesSelected.push(vehicle.number_plate);
				}
			}

			if (self.filtersByQuery && self.$route.query && self.$route.query.vehicleId) {
				var numberPlateFiltered = self.$route.query.vehicleId;
				setTimeout(() => {
					var vehicleSelected = self.vehicles.find(item => {
						return item.number_plate.toLowerCase() == numberPlateFiltered.toLowerCase();
					});
					if (vehicleSelected) self.vehiclesSelected.push(vehicleSelected.id);
				}, 200);
				if (self.vehicleIdFilterField == "code") {
					filterPlatesSelected.push(self.$route.query.code);
				} else {
					filterPlatesSelected.push(numberPlateFiltered);
				}

				if (self.$route.query.startDay) {
					self.startDate = moment(self.$route.query.startDay).startOf("day");
					self.endDate = moment(self.$route.query.startDay).endOf("day");
				}
			}

			if (this.vehicleIdFilterField == "code") {
				if (filterPlatesSelected.length > 0) query.vehicleCodes = filterPlatesSelected;
			} else {
				if (filterPlatesSelected.length > 0) query.plates = filterPlatesSelected;
			}

			let driverPlatesSelected = [];
			for (var i = 0; i < this.driversSelected.length; i++) {
				let driverId = this.driversSelected[i];
				let driver = this.drivers.find(function(x) {
					return x.id == driverId;
				});

				if (driver) driverPlatesSelected.push(driver.id);
			}

			if (driverPlatesSelected.length > 0) query.drivers = driverPlatesSelected;

			this.setDateTimeFilter();
			if (this.startDate) {
				query["dateRange.from"] = moment(this.startDate)
					.utc()
					.format();
			}

			if (this.endDate) {
				query["dateRange.to"] = moment(this.endDate)
					//.endOf("day")
					.utc()
					.format();
			}

			if (this.tableParams) {
				if (this.tableParams.sort && this.tableParams.sort.length > 0) {
					var sortParam = "";
					for (var i = 0; i < this.tableParams.sort.length; i++) {
						if (i > 0) sortParam += ",";

						var fieldAndDir = this.tableParams.sort[i];
						sortParam += `${fieldAndDir.field}|${fieldAndDir.dir}`;
					}

					query["sort"] = sortParam;
				}

				if (this.tableParams.page) {
					query["page"] = this.tableParams.page;
				}

				if (this.tableParams.pageSize) {
					query["pageSize"] = this.tableParams.pageSize;
				}
			}

			var evtForQuery = [];
			for (var i = 0; i < this.eventsSelected.length; i++) {
				var evtSelected = this.eventsSelected[i];
				var evts = this.eventsForQuery.filter(item => {
					return item.id == evtSelected;
				});

				if (evts && evts.length > 0) evtForQuery = evtForQuery.concat(evts);
			}
			if (evtForQuery.length > 0) {
				query.eventKey = evtForQuery.map(item => {
					return item.queryValue;
				});
			}

			return query;
		},
		getAlarms() {
			var self = this;

			var query = this.getQueryParams();
			bus.$emit("show-spinner-loading");

			ApiService.getAlarmsData(query)
				.then(res => {
					if (res && res.items) {
						var oldAlarms = self._.clone(self.alarmItems);
						self.alarmItems = [];
						self.alarmItems = res.items.map(a => {
							return {
								id: a.id,
								trip_id: a.trip_id,
								event_date: a.event_date,
								box_serial_number: a.box_serial_number,
								number_plate: a.number_plate,
								vehicle_id: a.vehicle_id,
								vehicle_name: a.vehicle_name,
								vehicle_code: a.vehicle_code,
								driver_id: a.driver_id,
								driver_name: a.driver_name,
								type: a.type,
								subtype: a.subtype,
								position_type: a.position_type,
								type_name: a.type_name,
								description: a.description,
								timestamp: a.timestamp,
								mas: a.mas,
								speed: a.speed,
								position: a.position,
								position_name: a.position_display_name,
								drive_direction: a.drive_direction,
								data: a.data,
								alarm_poi_display_name: a.alarm_poi_display_name,
								label_name: a.label_name,
								severity_description: a.severity_description,
								other_data: a.other_data,

								//custom field
								event_date_date: self.$options.filters.dateToString(a.event_date),
								event_date_time: self.$options.filters.timeToString(a.event_date),
								visible: self.getVisibilityOfItems(a, oldAlarms)
							};
						});

						self.totalCount = res.totalCount;

						if (self.alarmsMarker && self.alarmsMarker.length > 0 && self.alarmItems) {
							//remove markers if needed
							var markerToRemove = [];
							for (var i = 0; i < self.alarmsMarker.length; i++) {
								var ai = self.alarmsMarker[i];
								var alarm = self.alarmItems.find(m => {
									return m.id == ai.id;
								});

								if (!(alarm && alarm.visible)) {
									markerToRemove.push(ai.id);
								}
							}

							for (var i = 0; i < markerToRemove.length; i++) {
								let id = markerToRemove[i];
								let index = self.alarmsMarker.findIndex(function(a) {
									return a.id == id;
								});

								if (index >= 0) {
									self.alarmsMarker.splice(index, 1);
								}
							}
						}

						if (self.filtersByQuery && self.$route.query && self.$route.query.alarmId) {
							var alarm = self.alarmItems.find(item => {
								return item.id == self.$route.query.alarmId;
							});

							if (alarm) alarm.visible = true;

							self.onVisibilityItemChange(alarm);

							self.filtersByQuery = false;
						}

						//Discovery the position name by reverse geocoding
						if (self.useReverseGeocoding) self.setAddress();
						// if (self.alarmItems.length > 0) {
						// 	var alarmsWithoutPositionName = self.alarmItems.filter(function(item) {
						// 		return self._.isNull(item.position_name);
						// 	});

						// 	if (alarmsWithoutPositionName && alarmsWithoutPositionName.length > 0) {
						// 		//to do request and update items;
						// 		// for (var i = 0; i < alarmsWithoutPositionName.length: i++) {
						// 		// }
						// 	}
						// }
					}
				})
				.finally(() => {
					bus.$emit("hide-spinner-loading");
				});
		},
		setAddress() {
			var self = this;
			for (var i = 0; i < self.alarmItems.length; i++) {
				var item = self.alarmItems[i];

				if (self._.isNull(item.position_name) && item.position) {
					var params = {
						latitude: item.position.lat,
						longitude: item.position.lon
					};

					var getAddress = function(item, params) {
						ApiService.getReverseGeocoding(params).then(res => {
							var itemToUpdate = item;
							if (res && res.length > 0) {
								var newAddress = self._.find(res, function(item) {
									return (
										self._.find(item.types, function(x) {
											return x === "streetAddress";
										}) != null
									);
								});

								if (!newAddress) {
									newAddress = res[0];
								}

								var address = "";
								if (newAddress && newAddress.formattedAddress) {
									address = newAddress.formattedAddress;
								}
								itemToUpdate.position_name = address;
							}
						});
					};

					getAddress(item, params);
				}
			}
		},
		getVisibilityOfItems(newItem, oldAlarmItems) {
			if (newItem.position != null) {
				if (oldAlarmItems.length > 0) {
					var oldItem = oldAlarmItems.find(function(o) {
						return o.id == newItem.id;
					});

					if (oldItem) {
						return oldItem.visible;
					} else {
						return false;
					}
				}

				return false;
			}

			return null;
		}
		//#endregion
	},

	computed: {
		...mapGetters(["settings"]),
		startDateString() {
			return moment(this.startDate).format("DD MMMM YYYY");
		},
		endDateString() {
			return moment(this.endDate).format("DD MMMM YYYY");
		},
		mapClass: function() {
			if (this.showHorizontalTable) {
				return "mapwithHorizontalTable";
			}

			return " mapNoTables";
		},
		horizontalTableClass: function() {
			if (!this.showMap) {
				return " horizontal-table-without-map";
			}

			return "";
		},
		getStateMIcon() {
			return `../../${helpers.getStateMIcon(this.showMap)}`;
		},
		getStateHTIcon() {
			return `../../${helpers.getStateHTIcon(this.showHorizontalTable)}`;
		}
	}
};
